"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M9 14v2H7v-2h2zm1-14L9 12H7L6 0h4z"];
//# sourceMappingURL=high-priority.js.map